"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
const Terms = ({
  hasMultiYearTerm,
  minimumYears,
  showExactMonthlyPrice,
  showMonthlyPriceDisclaimer,
  isHighlightSavings,
  isPromoPayVariant
}) => {
  if (hasMultiYearTerm) {
    return /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: `pricing.qualifiers.terms.${isPromoPayVariant || isHighlightSavings ? 'firstYear' : 'multiYear'}`,
      values: {
        numYears: minimumYears
      }
    });
  }
  if (showExactMonthlyPrice && showMonthlyPriceDisclaimer) {
    return /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "pricing.qualifiers.terms.first-year-annual-purchase-required"
    });
  }
  return /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "pricing.qualifiers.terms.firstYear"
  });
};
Terms.propTypes = {
  hasMultiYearTerm: _propTypes.default.bool,
  minimumYears: _propTypes.default.number,
  showExactMonthlyPrice: _propTypes.default.bool,
  showMonthlyPriceDisclaimer: _propTypes.default.bool,
  isHighlightSavings: _propTypes.default.bool,
  isPromoPayVariant: _propTypes.default.bool
};
var _default = exports.default = Terms;